var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#1E2447",
    strokeWidth: 0.5,
    d: "M8.413.679C8.418.335 8.316.04 8.179 0h-.607c-.136.044-.234.3-.234.679 0 .379-.278 11.938-.415 17.856 0 .391.164.696.387.696h1.148c.224 0 .398-.305.388-.696C8.695 12.583 8.55 6.63 8.413.679z",
    transform: "translate(-307 -886) translate(270 416) translate(15) translate(0 461) translate(22 9) translate(2.308 .385)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#1E2447",
    strokeLinecap: "round",
    strokeWidth: 0.6,
    d: "M1.538 3.462L13.846 3.462",
    transform: "translate(-307 -886) translate(270 416) translate(15) translate(0 461) translate(22 9) translate(2.308 .385) translate(0 1.538) translate(0 6.923)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1E2447"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.179 0.769L2.179 1.923 2.436 1.923 2.436 2.692 1.41 2.692 1.41 1.923 1.667 1.923 1.667 0.769z",
    transform: "translate(-307 -886) translate(270 416) translate(15) translate(0 461) translate(22 9) translate(2.308 .385) translate(0 1.538) translate(0 6.923) translate(0 .154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.333 0c.284 0 .513.23.513.513 0 .283-.23.513-.513.513-.19 0-.355-.103-.444-.256H.957c-.089.153-.254.256-.444.256C.23 1.026 0 .796 0 .513 0 .23.23 0 .513 0c.19 0 .355.103.444.256h1.932C2.978.103 3.144 0 3.333 0z",
    transform: "translate(-307 -886) translate(270 416) translate(15) translate(0 461) translate(22 9) translate(2.308 .385) translate(0 1.538) translate(0 6.923) translate(0 .154)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1E2447"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.179 0.769L2.179 1.923 2.436 1.923 2.436 2.692 1.41 2.692 1.41 1.923 1.667 1.923 1.667 0.769z",
    transform: "translate(-307 -886) translate(270 416) translate(15) translate(0 461) translate(22 9) translate(2.308 .385) translate(0 1.538) translate(0 6.923) translate(11.538 .154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.333 0c.284 0 .513.23.513.513 0 .283-.23.513-.513.513-.19 0-.355-.103-.444-.256H.957c-.089.153-.254.256-.444.256C.23 1.026 0 .796 0 .513 0 .23.23 0 .513 0c.19 0 .355.103.444.256h1.932C2.978.103 3.144 0 3.333 0z",
    transform: "translate(-307 -886) translate(270 416) translate(15) translate(0 461) translate(22 9) translate(2.308 .385) translate(0 1.538) translate(0 6.923) translate(11.538 .154)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#1E2447",
    strokeLinecap: "round",
    strokeWidth: 0.6,
    d: "M1.538 3.462L12.308 3.462",
    transform: "translate(-307 -886) translate(270 416) translate(15) translate(0 461) translate(22 9) translate(2.308 .385) translate(0 1.538) translate(.77)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1E2447"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.179 0.769L2.179 1.923 2.436 1.923 2.436 2.692 1.41 2.692 1.41 1.923 1.667 1.923 1.667 0.769z",
    transform: "translate(-307 -886) translate(270 416) translate(15) translate(0 461) translate(22 9) translate(2.308 .385) translate(0 1.538) translate(.77) translate(0 .154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.333 0c.284 0 .513.23.513.513 0 .283-.23.513-.513.513-.19 0-.355-.103-.444-.256H.957c-.089.153-.254.256-.444.256C.23 1.026 0 .796 0 .513 0 .23.23 0 .513 0c.19 0 .355.103.444.256h1.932C2.978.103 3.144 0 3.333 0z",
    transform: "translate(-307 -886) translate(270 416) translate(15) translate(0 461) translate(22 9) translate(2.308 .385) translate(0 1.538) translate(.77) translate(0 .154)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1E2447"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.179 0.769L2.179 1.923 2.436 1.923 2.436 2.692 1.41 2.692 1.41 1.923 1.667 1.923 1.667 0.769z",
    transform: "translate(-307 -886) translate(270 416) translate(15) translate(0 461) translate(22 9) translate(2.308 .385) translate(0 1.538) translate(.77) translate(10 .154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.333 0c.284 0 .513.23.513.513 0 .283-.23.513-.513.513-.19 0-.355-.103-.444-.256H.957c-.089.153-.254.256-.444.256C.23 1.026 0 .796 0 .513 0 .23.23 0 .513 0c.19 0 .355.103.444.256h1.932C2.978.103 3.144 0 3.333 0z",
    transform: "translate(-307 -886) translate(270 416) translate(15) translate(0 461) translate(22 9) translate(2.308 .385) translate(0 1.538) translate(.77) translate(10 .154)"
  }))))), /*#__PURE__*/React.createElement("path", {
    stroke: "#1E2447",
    strokeWidth: 0.2,
    d: "M8.748 13.251L6.923 16.199M8.598 7.185L7.194 10.154M8.748 19.001L6.923 16.199M8.748 13.251L7.194 10.154M8.598 7.185L7.395 3.637 8.413.679",
    transform: "translate(-307 -886) translate(270 416) translate(15) translate(0 461) translate(22 9) translate(2.308 .385)"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastIcon);
export default __webpack_public_path__ + "static/media/mast_icon.514d5388.svg";
export { ForwardRef as ReactComponent };